import React from 'react';
import { GetApp } from '@material-ui/icons';
import { ExportButton } from './ReviewCampaignDrawer.styled';

const ExportDeliveries = ({ deliveries, campaignName, date }) => {
  const formatDate = date => {
    return date
      .toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      })
      .replace(/\//g, '-');
  };

  const exportToCSV = () => {
    if (!deliveries || deliveries.length === 0) {
      alert('No deliveries to export');
      return;
    }

    const headers = [
      'Stage Name',
      'Message Subject',
      'Recipient Full Name',
      'Recipient Email Address',
      'M1 ID',
      'Member ID',
    ];

    const csvRows = deliveries.map(delivery => [
      delivery.stageName || '',
      delivery.subject || '',
      delivery.contactName || '',
      delivery.contactEmail || '',
      delivery.nrdsId || '',
      delivery.memberId || '',
    ]);

    // Combine headers and data
    const csvContent = [headers, ...csvRows]
      .map(row => row.map(field => `"${field}"`).join(','))
      .join('\n');

    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);

      // Generate filename: CampaignName_MM-DD-YYYY.csv
      const formattedDate = formatDate(date);
      const filename = `${campaignName}_${formattedDate}.csv`;
      link.setAttribute('download', filename);

      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <ExportButton onClick={exportToCSV}>
      <GetApp />
      Export
    </ExportButton>
  );
};

export default ExportDeliveries;
